// extracted by mini-css-extract-plugin
export var checkboxContainer = "RjGeT8DP3ifPsiR82di0";
export var checkboxIcon = "MPCAYhs9prW_83yMKnID";
export var checkboxIconBorder = "BAo42OcoSS_ExdbZKRqw";
export var checkboxInput = "SmYrYSaozQYOYcPeFXo8";
export var copyButton = "fYm13lPWvHuHdnHnO5we";
export var form = "raEunxlqZW_fYdEPthNU";
export var helpText = "xZABrzuUxbxAOHdbmpuf";
export var seedWrapper = "Sutyg2EwLqXwiZVc0xJN";